<script>
  import { onDestroy, onMount } from "svelte"
  import { derived } from "svelte/store"
  import { getContext } from "./context"

  export let key
  export let value = null
  export let disabled = false
  export let index = -1

  const { combobox, cursor, handles } = getContext()

  const option = {
    key,
    value,
    disabled,
    $element: null,
    index
  }

  function handleClick() {
    if (disabled) {
      return
    }
    combobox.select(value)
  }

  const active = derived(cursor, ({ item }) => {
    return !!item && item.key === key
  })

  function handleMouseenter() {
    if (disabled) {
      return
    }
    cursor.select(option)
  }

  onMount(() => {
    $combobox.options = [...$combobox.options, option]
      .sort((a, b) => (a.index !== undefined && b.index !== undefined) ? a.index - b.index : 0);

    if (combobox.selected(value)) {
      cursor.reset()
    }
  })

  onDestroy(() => {
    $combobox.options = $combobox.options.filter(item => item.key !== key);

    if ($active) {
      cursor.reset()
    }
  })
</script>

<li
  role="option"
  {...$$restProps}
  on:mouseenter={handleMouseenter}
  on:click|preventDefault={handleClick}
  bind:this={option.$element}
  aria-disabled={disabled ? "true" : "false"}
  aria-selected={combobox.selected(value) ? "true" : "false"}
  id={handles.new("option")}
>
  <slot active={$active} selected={combobox.selected(value)} />
</li>
